<template>
  <div class="container-fluid">
    <nav v-if="!load" class="navbar navbar-expand-lg navbar-light bg-light mb-3">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <div class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            v-model="filter"
            v-on:keyup.enter="goToSearch"
            aria-label="Search"
          />
          <button class="btn btn-outline-success my-2 my-sm-0" @click="goToSearch">
            <span v-if="$route.params.language === 'pt'">Buscar</span>
            <span v-if="$route.params.language === 'en'">Search</span>
            <span v-if="$route.params.language === 'es'">Buscar</span>
          </button>
        </div>
      </div>
    </nav>

    <div v-if="!load && eventsTracks.length < 1" class="alert alert-warning mt-3" role="alert">
      <span v-if="$route.params.language === 'pt'">Nenhum evento encontrados</span>
      <span v-if="$route.params.language === 'en'">No event found</span>
      <span v-if="$route.params.language === 'es'">Ningún evento encontrado</span>
    </div>

    <div v-if="load" class="text-center text-secondary mt-5 mb-3">
      <i class="fas fa-3x fa-spinner fa-pulse"></i>
      <br />
      <span v-if="$route.params.language === 'pt'">Buscando dados</span>
      <span v-if="$route.params.language === 'en'">Buscando dados</span>
      <span v-if="$route.params.language === 'es'">Buscando dados</span>
    </div>

    <div v-if="!load && eventsTracks" class="main">
      <div class="row">
        <div class="col-sm-3 col-md-2">
          <div class="box__collapser">
            <button
              class="btn btn-secondary"
              type="button"
              data-toggle="collapse"
              data-target="#filterBox"
              aria-controls="navbarSupportedContent"
              aria-expanded="true"
              aria-label="Toggle navigation"
            >
              <i class="fas fa-bars"></i>
            </button>
            <h6>Filtros</h6>
          </div>
          <div class="collapse show" id="filterBox">
            <ul class="list-group">
              <li v-for="track in tracks" :key="track.id" class="list-group-item check">
                <label class="check__label w__full">
                  <span>{{ track.name }}</span>
                  <input type="checkbox" :id="track.id" :value="track.id" v-model="checkedT" />
                  <div class="check__body">
                    <div class="check__slide"></div>
                  </div>
                </label>
              </li>
            </ul>
            <a tag="a" @click="filterTracks()" class="btn btn-success btn-sm">Filtrar</a>
          </div>
        </div>
        <div class="col-10">
          <div v-if="filterError" class="alert alert-warning">Selecione um track</div>

          <slot-event
            style="margin-top: 10px;"
            v-for="(event, index) in eventsTracks"
            :key="index"
            :time="index"
            :event="event"
          />
        </div>
      </div>
    </div>
    <EventInfo :event="eventSelected" />
  </div>
</template>
<script>
import { eventBus } from "../main";
import SlotEvent from "./search/SlotEvent.vue";
import EventInfo from "./event/EventInfo.vue";
import json from "../data/day16.json";
import { HTTP } from "../axios";
var _ = require("lodash");
export default {
  name: "Search",
  data() {
    return {
      times: {},
      events: {},
      filter: "",
      list: [],
      eventsSearch: {},
      load: true,
      eventSelected: undefined,
      checkedT: [], //localStorage.getItem('setTracks'),
      eventsTracks: {},
      tracksChecked: [],
      tracks: [],
      tracksFilter: [],
      filterError: false
    };
  },
  watch: {
    day() {
      this.getSlots();
    },
    $route(day, language) {
      this.getSlots();
    },
    checkedT() {
      this.getTracksChecked();
    }
  },
  computed: {
    hasSeach() {
      if (this.eventsSearch.length > 0) {
        return true;
      }

      if (!this.load && this.eventsSearch.length < 1) {
        return false;
      }
    }
  },
  methods: {
    getTracksChecked() {
      this.tracksChecked = [];
      for (let index = 0; index < this.tracks.length + 1; index++) {
        if (this.checkedT.indexOf(this.tracks[index]) >= 0) {
          this.tracksChecked.push(this.tracks[index].id);
        }
        //console.log(this.tracks[index])
      }
    },
    getRoomId(rooms, checked) {
      if (!rooms) {
        console.log("Nao tem salas registradas");
      } else {
        for (let index = 0; index < rooms.length + 1; index++) {
          this.checked.push(index);
        }
      }
    },
    getTracksCheck() {
      this.load = true;
      HTTP.post(
        "grid-agenda-by-tracks/e984dc69-0e1b-4b23-b5e9-9158d8ad9533/pt"
      ).then(response => {
        this.tracksChecked = response.data;
        this.load = false;
      });
    },
    getTracks() {
      this.load = true;
      HTTP.get(
        "get-event-tracks/e984dc69-0e1b-4b23-b5e9-9158d8ad9533/" +
          this.$route.params.language
      ).then(response => {
        this.tracks = response.data;
        this.load = false;
        this.getTrackId(response.data);
      });
    },
    getTrackId(tracks, checkedT) {
      if (!tracks) {
        console.log("Nao tem tracks registradas");
      } else {
        // tracks.forEach( element => {
        //   this.tracksChecked.push(element.id)
        // });
      }
    },
    goToSearch() {
      window.location.href =
        "/search/" + this.$route.params.language + "/" + this.filter;
    },
    getSlotsSearch() {
      HTTP.get(
        "search/e984dc69-0e1b-4b23-b5e9-9158d8ad9533/" +
          this.filter +
          "/" +
          this.$route.params.language
      ).then(response => {
        this.eventsSearch = response.data.slots;
        this.load = false;
      });
    },
    filterTracks() {
      this.tracksFilter.pop();
      this.tracksFilter.push(this.checkedT);

      if (this.tracksFilter[0].length > 0) {
        this.filterError = false;
        return this.getTracksCheck();
      }

      this.filterError = true;
    },
    getTracksCheck() {
      this.load = true;
      HTTP.post(
        "grid-agenda-by-tracks/e984dc69-0e1b-4b23-b5e9-9158d8ad9533/pt",
        { tracks: this.tracksFilter }
      ).then(response => {
        this.eventsTracks = response.data.slots;
        this.load = false;
      });
    }
  },
  components: {
    SlotEvent,
    EventInfo
  },
  mounted() {
    this.filter = this.$route.params.term;

    this.getTracks();
  },
  created() {
    eventBus.$on("selectEvent", eventSelected => {
      this.eventSelected = eventSelected;
    });
  }
};
</script>

<style lang="scss" scoped>
/* .time-column{
    display: flex;
    align-items: center;
    justify-content: center;
  } */
.time-event {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
}
.event {
  width: 100%;
  display: inline-block;
  vertical-align: top;
  margin: 12px 6px !important;
}
.check {
  padding: 0;
  &__label {
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 6px 12px;
    input[type="checkbox"] {
      display: none;
    }
  }
  &__body {
    position: relative;
    width: 20px;
    min-width: 20px;
    height: 10px;
    background-color: #ccc;
    display: inline-block;
    border-radius: 9px;
    -webkit-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    -moz-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
  }
  &__slide {
    position: absolute;
    top: 0;
    left: -3px;
    width: 10px;
    height: 10px;
    background-color: #fff;
    border-radius: 50%;
    -webkit-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    -moz-box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
    box-shadow: 0px 2px 3px 1px rgba(138, 141, 148, 0.66);
  }
}
input[type="checkbox"]:checked + .check__body {
  background-color: #4ae086;
  .check__slide {
    left: inherit;
    right: -3px;
  }
}
.btn.btn-success.btn-sm {
  color: #fff;
  font-weight: bold;
  margin: 10px 0 0 0;
}
.box__collapser {
  padding: 0 0 9px 0;
  h6 {
    display: inline-block;
  }
}
@media (min-width: 770px) {
  .event {
    width: 32%;
  }
}
@media (min-width: 560px) {
  .collapse {
    //display: block;
  }
  .box__collapser {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tracks.vue